import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class LeagueIterationMemberService {
    url: string = environment.api.endpoint;

    constructor(private http: HttpClient) { }

    getById(id: string): any {
        return this.http.get(`${this.url}/leagueiterationmember/${id}`);
    }

    getAllByIterationId(filter: any): any {
        return this.http.get(`${this.url}/leagueiterationmembers/iteration/`, { params: filter });
    }

    addMembersToIteration(data: any): any {
        return this.http.post(`${this.url}/leagueiterationmember/create`, data);
    }

    update(id: string, data: any): any {
        return this.http.post(`${this.url}/leagueiterationmember/update/${id}`, data);
    }

    delete(data: any): any {
        return this.http.post(`${this.url}/leagueiterationmember/delete`, data);
    }

    createCheckoutSession(data: any): any {
        return this.http.post(`${this.url}/leagueiterationmember/create/checkoutsession`, data);
    }

    getCheckoutSession(apiKey: string, sessionId: string): any {
        const headers = new HttpHeaders({
            'ApiKey': apiKey
        });

        return this.http.get(`${this.url}/leagueiterationmember/checkoutsession/${sessionId}`, { params: { apiKey: apiKey }, headers: headers });
    }
}

